/**
 * Detectors for the OTP-login → register handoff.
 *
 * These match verbatim AuthService exception strings. Changing the backend
 * copy without updating the regexes silently breaks the handoff (user sees
 * the old dead-end) or the stale-token recovery (user retries a dead JWT).
 */

export function isUnregisteredPhone(err: unknown): boolean {
  const response = (err as { response?: { status?: number; data?: { message?: string } } })
    ?.response;
  return (
    response?.status === 401 &&
    /no account found/i.test(response?.data?.message ?? '')
  );
}

export function isStalePhoneToken(err: unknown): boolean {
  const response = (err as { response?: { status?: number; data?: { message?: string } } })
    ?.response;
  return (
    response?.status === 400 &&
    /verification token|phone verification/i.test(response?.data?.message ?? '')
  );
}
